import classnames from 'classnames';
import React from 'react';

import { Icon } from '@eika/icon';
import '@eika/label-style';

import { LabelProps } from './types';

const Label = ({
    id,
    text,
    icon,
    type = 'default',
    size = 'standard',
    className,
    style,
    ...rest
}: LabelProps): React.JSX.Element => {
    return (
        <span id={id} className={classnames('sgw-label', type, `${type}--${size}`, className)} style={style} {...rest}>
            {icon && <Icon type={icon} />}
            <span>{text}</span>
        </span>
    );
};

export default Label;
